import { render, staticRenderFns } from "./SalesOrganisationsTab.vue?vue&type=template&id=4384e0e8&scoped=true&"
import script from "./SalesOrganisationsTab.vue?vue&type=script&lang=js&"
export * from "./SalesOrganisationsTab.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrganisationsTab.vue?vue&type=style&index=0&id=4384e0e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4384e0e8",
  null
  
)

export default component.exports